<template lang="pug">
    div.submit-repair-info
        el-dialog(
            :title="dialogData.title"
            :visible.sync="dialogData.show"
            :close-on-click-modal="false"
            :width="['SXX_2', 'SXX_3'].includes(dialogData.equityType) ? '967px' : '686px'"
            center
            @close="resetData"
        )
            div.submit-repair-box(v-loading="loading")
                div.account-info(v-if="['SXX_2', 'SXX_3'].includes(dialogData.equityType)")
                    div.info-title 收款人信息
                    div.info-tips *若收款信息错误或发生变更，请及时拨打952149进行确认
                    div.info-item
                        div.item-label 开户银行：
                        div.item-value {{ accountData.bankName | fieldVaild }}
                    div.info-item
                        div.item-label 银行账号：
                        div.item-value {{ accountData.bankAccount | fieldVaild }}
                    div.info-item
                        div.item-label 账户名：
                        div.item-value {{ accountData.accountName | fieldVaild }}
                div(style="flex: 1; padding: 20px")
                    el-form(
                        :model="formData"
                        :rules="rules"
                        ref="formData"
                        label-width="152px"
                    )
                        el-form-item.padding-left-10(
                            label="进出厂时间："
                            prop="worksTime"
                            v-if="dialogData.equityType === 'TRAVEL_SUBSIDY' || dialogData.equityType === 'TRAVEL_SUBSIDY_2'"
                        )
                            CustomDateRange(
                                options=dataRangeOptions
                                v-model="formData.worksTime"
                                @input="worksTimeChange"
                            )
                        el-form-item.padding-left-10(
                            v-if="dialogData.equityType === 'TRAVEL_SUBSIDY' || dialogData.equityType === 'TRAVEL_SUBSIDY_2'"
                            label="维修天数："
                            prop="repairDays"
                        ) {{ formData.repairDays || '--'}}
                        el-form-item.padding-left-10(
                            label="维修金额："
                            prop="repairAmount"
                        )
                            el-number-input(
                                v-model.trim="formData.repairAmount"
                                clearable
                                placeholder="请输入"
                                maxlength="11"
                            )
                                span(slot="suffix") 元
                        el-form-item.padding-left-10(
                            v-if="dialogData.equityType === 'TRAVEL_SUBSIDY' || dialogData.equityType === 'TRAVEL_SUBSIDY_2'"
                            label="是否有配件等待期:"
                            prop="isWait"
                        )
                            el-radio-group(
                                v-model.trim="formData.isWait"
                            )
                                el-radio(
                                    v-for="(item, index) in waitOptions"
                                    :key="item.value"
                                    :label="item.value"
                                ) {{ item.label }}
                        el-form-item.padding-left-10(
                            v-if="formData.isWait === 'have' && (dialogData.equityType === 'TRAVEL_SUBSIDY' || dialogData.equityType === 'TRAVEL_SUBSIDY_2')"
                            label="配件等待天数:"
                            prop="waitDays"
                        )
                            el-integer-input(
                                v-model.trim="formData.waitDays"
                                placeholder="请输入"
                                clearable
                                maxlength="3"
                            )
                                span(slot="suffix") 天
                        el-form-item.padding-left-10(
                            v-if="dialogData.equityType === 'TRAVEL_SUBSIDY' || dialogData.equityType === 'TRAVEL_SUBSIDY_2'"
                            label="申请补贴天数:"
                            prop="subsidyDays"
                        )
                            el-integer-input(
                                v-model.trim="formData.subsidyDays"
                                placeholder="请输入"
                                clearable
                                maxlength="3"
                                @blur="calsSubsidyAmount"
                            )
                                span(slot="suffix") 天
                        el-form-item.padding-left-10(
                            v-if="dialogData.equityType === 'TRAVEL_SUBSIDY' || dialogData.equityType === 'TRAVEL_SUBSIDY_2'"
                            label="申请补贴金额:"
                            prop="subsidyAmount"
                        )
                            span {{ formData.subsidyAmount || '--' }}元
                        el-form-item.padding-left-10(
                            label="维修凭证:"
                            prop="repairCertificate"
                        )
                            div.tips
                                span(v-if="dialogData.equityType === 'TRAVEL_SUBSIDY' || dialogData.equityType === 'TRAVEL_SUBSIDY_2'") {{ accidentTypeTips[dialogData.data.accidentType] || '--'}}
                                span(v-else) {{dialogData.equityType | photoTip}}
                            el-upload.upload(
                                :class="{ 'limit' : repairCertificateHide}"
                                ref="upload"
                                action=""
                                accept="image/png,image/jpg,image/jpeg,image/bmp"
                                list-type="picture-card"
                                :auto-upload="false"
                                :file-list="formData.repairCertificate"
                                :limit="15"
                                :on-change="arriveCerChange"
                                :on-exceed="onExceed"
                            )
                                span(
                                    slot="default"
                                    ref="addImg"
                                ) 添加图片
                                div.content-box(
                                    slot="file"
                                    slot-scope="{file}"
                                )
                                    img(
                                        class="el-upload-list__item-thumbnail"
                                        :src="file.url"
                                        @click="arriveShowImage(file.url)"
                                    )
                                    //- i.el-icon-error(
                                    //-     @click="delectFile(file)"
                                    //- )
                                    div.delete-imgs(@click="delectFile(file)")
                                        svg-icon(
                                            icon-class="delete-img"
                                            className="delete-img"
                                        )
                    div.footer
                        el-button.button(
                            @click="close"
                            round
                        ) 取消
                        el-button.button(
                            @click="handleStagingClick"
                            class="staging-btn"
                            :loading="stagingLoading"
                            v-if="dialogData.data && dialogData.data.status === 'TO_APPLY'"
                            round
                        ) 暂存
                        el-button.button(
                            :loading="btnLoading"
                            round
                            type="primary"
                            @click="handleSubmit"
                            :disabled="canSubmit"
                        ) 提交
        image-viewer(
            v-if="showViewer"
            :showViewer.sync="showViewer"
            :currentUrl="currentUrl"
            :urlList="urlList"
        )
</template>
<script>
import lrz from 'lrz';
import { mapState } from 'vuex';
import ElNumberInput from '@/components/elementUi/diy/ElNumberInput.vue';
import ElIntegerInput from '@/components/elementUi/diy/ElIntegerInput.vue';
import ImageViewer from '@/components/ImageViewer.vue';
import { subsidyApplyApis } from '@/api';
import oss from '@/utils/oss';
import { handleParameter, photoTip, dateFormat } from '@/filters';
import CustomDateRange from '@/components/FormComponent/CustomDateRange.vue';

export default {
    components: {
        ElNumberInput,
        ImageViewer,
        ElIntegerInput,
        CustomDateRange,
    },
    props: {
        dialogData: {
            type: Object,
            default() {
                return {
                    title: '',
                    show: false,
                    data: {},
                };
            },
        },
    },
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
    },
    data() {
        const positiveInteger = (rule, value, callback) => {
            if (!/^([1-9]\d{0,2})?$/.test(value)) {
                callback(new Error('请填写1~999之间的正整数'));
            } else {
                if (value < 1) {
                    callback(new Error('仅支持输入大于0的正整数'));
                    return;
                }
                if (value > this.compareRepair) {
                    callback(new Error('不能超过维修天数，请核对修改'));
                    return;
                }
                if (value > 999) {
                    callback(new Error('最大数值限制为999'));
                    return;
                }
                callback();
            }
        };
        return {
            accountData: {},
            dataRangeOptions: {
                format: 'yyyy/MM/dd HH:mm:ss',
                'start-placeholder': '进厂时间',
                'end-placeholder': '出厂时间',
                editable: false,
                clearable: true,
            },
            loading: false,
            btnLoading: false,
            stagingLoading: false, // 暂存按钮的loading状态
            formData: {
                repairAmount: '',
                repairCertificate: [],
                worksTime: [],
                repairDays: null,
                isWait: null,
                waitDays: null,
                subsidyDays: null,
                subsidyAmount: null,
            },
            rules: {
                worksTime: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: [
                            'blur',
                            'change',
                        ],
                    },
                ],
                repairAmount: [
                    {
                        required: true,
                        message: '请输入正确的金额',
                        trigger: [
                            'blur',
                            'change',
                        ],
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || value === '0' || value === '0.' || value === '0.0' || value === '0.00') {
                                callback(new Error('请输入正确的金额'));
                            }
                            if (value !== '' && !/^([1-9]\d{0,7}(\.\d{0,2})?$)|^(0(\.\d{0,2}))$/.test(value)) {
                                callback(new Error('整数位最多8位，小数位最多2位'));
                            }
                            callback();
                        },
                        trigger: [
                            'blur',
                            'change',
                        ],
                    },
                ],
                repairCertificate: [
                    {
                        required: true,
                        message: '请上传维修凭证',
                        trigger: [
                            'blur',
                            'change',
                        ],
                    },
                ],
                isWait: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: 'blur',
                    },
                ],
                waitDays: [
                    {
                        required: true,
                        message: '请输入配件等待天数',
                        trigger: 'blur',
                    },
                    {
                        validator: positiveInteger,
                        trigger: [
                            'blur',
                            'change',
                        ],
                    },
                ],
                subsidyDays: [
                    {
                        required: true,
                        message: '请输入申请补贴天数',
                        trigger: 'blur',
                    },
                    {
                        validator: positiveInteger,
                        trigger: [
                            'blur',
                            'change',
                        ],
                    },
                ],
            },
            repairCertificateHide: false,
            showViewer: false,
            currentUrl: '',
            urlList: [],
            sdkPage: {
                WXWY: 'repair_data_popup',
                GCWY: 'repair_data_popup',
                CCWY: 'repair_data_popup',
                SXX: 'repair_data_popup',
                ZJWY: 'repair_data_popup',
                TRAVEL_SUBSIDY: 'repair_data_popup',
            },
            waitOptions: [
                {
                    label: '有',
                    value: 'have',
                },
                {
                    label: '无',
                    value: 'notHave',
                },
            ],
            canSubmit: false,
            // 维修天数用于校验
            compareRepair: null,
            accidentTypeTips: {
                NORMAL_DAMAGE: '包含县级以上公安机关立案证明照片、县级以上公安机关未找回证明照片、车辆行驶证、身份证、收款人开户行信息、了结协议、凯励程服务函或业务清单',
                ROBBERY_DAMAGE: '包含县级以上公安机关立案证明照片、县级以上公安机关发还证明照片、车辆维修结算单、车辆行驶证、身份证、收款人开户行信息、了结协议、凯励程服务函或业务清单',
                ROBBERY_LOST: '包含县级以上公安机关立案证明照片、县级以上公安机关未找回证明照片、车辆行驶证、身份证、收款人开户行信息、了结协议、凯励程服务函或业务清单',
            },
            canApplyCheck: true,
        };
    },
    created() {
    },
    mounted() {
        this.initData();
        if (['SXX_2', 'SXX_3'].includes(this.dialogData.equityType)) {
            this.getAccount();
        }
    },
    methods: {
        async getAccount() {
            await subsidyApplyApis.getFinanceAccount().then((res) => {
                this.accountData = res.data || {};
            });
        },
        async initData() {
            this.loading = true;
            try {
                const { data } = await subsidyApplyApis.getRepairInfo(this.dialogData.data.id);
                if (data) {
                    if (data.enterTime && data.outTime) {
                        this.$set(this.formData, 'worksTime', [new Date(dateFormat(data.enterTime, 'YYYY/MM/DD HH:mm')), new Date(dateFormat(data.outTime, 'YYYY/MM/DD HH:mm'))]);
                        this.formData.enterTime = data.enterTime;
                        this.formData.outTime = data.outTime;
                    }
                    this.canApplyCheck = false;
                    this.worksTimeChange(this.formData.worksTime);
                    this.formData.subsidyDays = data.subsidyDays;
                    this.formData.waitDays = data.waitDays || '';
                    if (typeof data.waitDays === 'number') {
                        this.formData.isWait = data.waitDays ? 'have' : 'notHave';
                    } else {
                        this.formData.isWait = null;
                    }
                    this.formData.subsidyAmount = data.subsidyAmount;
                    this.formData.repairAmount = data.repairAmount || '';
                    if (data.repairCertificate && data.repairCertificate.length) {
                        this.downLoadFile(data.repairCertificate);
                    }
                }
            } finally {
                this.loading = false;
            }
        },
        downLoadFile(urls) {
            const promiseList = [];
            const resList = [];
            for (let i = 0, len = urls.length; i < len; i++) {
                promiseList.push(oss.downloadFile(urls[i], 'PRIVATE', 1000)
                    .then((res) => {
                        resList[i] = {
                            url: res,
                            name: urls[i],
                            hasUpload: true,
                        };
                    })
                    .catch((err) => {
                        this.formData.repairCertificate[i] = err;
                    }));
            }
            Promise.all(promiseList).finally(() => {
                resList.forEach((val) => {
                    this.formData.repairCertificate.push(val);
                });
                if (resList.length > 14) this.repairCertificateHide = true;
                this.loading = false;
            });
        },
        async uploadToOss(file) {
            const needUploadFile = [];
            // 已上传的不再上传
            const hasUploadFileName = [];
            file.forEach((val) => {
                if (val.hasUpload) {
                    hasUploadFileName.push(val.name);
                } else {
                    needUploadFile.push(val);
                }
            });

            try {
                let fileName = [];
                if (needUploadFile.length > 0) {
                    // eslint-disable-next-line
                    let fileList = [];
                    for (let index = 0; index < needUploadFile.length; index++) {
                        const {
                            // eslint-disable-next-line
                            file,
                            origin,
                        // eslint-disable-next-line no-await-in-loop
                        } = await lrz(needUploadFile[index].raw);
                        if (!file.name) file.name = origin.name;
                        fileList.push(file);
                    }
                    const data = await oss.uploadFiles(fileList, 'equity');
                    fileName = data.map(val => val.name);
                }
                return [
                    ...hasUploadFileName,
                    ...fileName,
                ];
            } catch (error) {
                throw new Error(error);
            }
        },
        arriveCerChange(file, fileList) {
            this.fileChange(file, fileList);
        },
        fileChange(file, fileList) {
            if (!this.isAllowdUpload(file)) {
                this.formData.repairCertificate = fileList.filter(val => val.uid !== file.uid);
                return;
            }
            this.formData.repairCertificate = fileList;
            if (this.formData.repairCertificate.length > 14) this.repairCertificateHide = true;
        },
        // 上传图片限制
        isAllowdUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('图片大小不能超过20MB');
                return false;
            }
            const imgStr = 'image/png,image/jpg,image/jpeg,image/bmp';
            if (imgStr.indexOf(file.raw.type) < 0) {
                this.$message.error('请选择正确的图片格式文件，仅支持JPG、BMP、PNG格式');
                return false;
            }
            return true;
        },
        onExceed() {
            this.$message.error('最多添加15张图片');
        },
        arriveShowImage(url) {
            this.currentUrl = url;
            this.urlList = this.formData.repairCertificate.map(val => val.url);
            this.showViewer = true;
        },
        delectFile(file) {
            this.formData.repairCertificate = this.formData.repairCertificate.filter(val => val.uid !== file.uid);
            this.repairCertificateHide = false;
        },
        worksTimeChange(val) {
            this.canSubmit = false;
            const stime = Date.parse(new Date(val[0]));
            const etime = Date.parse(new Date(val[1]));
            // 两个时间戳相差的毫秒数
            const usedTime = etime - stime;
            let time = '';
            // 计算相差的天数
            const days = Math.floor(usedTime / (24 * 3600000));
            if (days <= 0) {
                this.$message({
                    message: '不满24小时不能申请',
                    type: 'error',
                    duration: 3 * 1000,
                });
                this.canSubmit = true;
            } else if (days > 0) {
                time = `${days}天`;
                if (this.canApplyCheck) this.applyCheck(val);
            }
            // 计算天数后剩余的毫秒数
            const leave1 = usedTime % (24 * 3600000);
            // 计算出小时数
            const hours = Math.floor(leave1 / 3600000);
            if (hours > 0) time += `${hours}小时`;
            this.compareRepair = usedTime / (24 * 3600000);
            this.formData.repairDays = time;
            this.canApplyCheck = true;
        },
        async applyCheck(val) {
            this.formData.enterTime = this.$dayjs(val[0]).toISOString();
            this.formData.outTime = this.$dayjs(val[1]).toISOString();
            const { vin, id } = this.dialogData.data;
            await subsidyApplyApis.travelapply({
                enterTime: this.formData.enterTime,
                outTime: this.formData.outTime,
                vin,
                id,
            })
                .then(() => {
                })
                .catch(({ data }) => {
                    if (data.code === 16407) {
                        this.$message({
                            type: 'error',
                            message: data.msg,
                        });
                        this.canSubmit = true;
                        return;
                    }
                    this.$message({
                        type: 'error',
                        message: data.msg,
                    });
                });
        },
        /**
         * 构造提交维修资料的参数
         * 暂存和提交参数相同
         */
        async constructRepairInfParams() {
            let repairCertificate = [];
            if (this.formData.repairCertificate && this.formData.repairCertificate.length) {
                repairCertificate = await this.uploadToOss(this.formData.repairCertificate);
            }
            let params = null;
            if (['TRAVEL_SUBSIDY', 'TRAVEL_SUBSIDY_2'].includes(this.dialogData.equityType)) {
                const {
                    enterTime, outTime, isWait, waitDays, subsidyDays, subsidyAmount,
                } = this.formData;
                params = {
                    enterTime,
                    outTime,
                    waitDays: isWait === 'have' ? waitDays : 0,
                    subsidyDays,
                    subsidyAmount,
                };
            }
            return {
                repairCertificate: repairCertificate && repairCertificate.length ? repairCertificate : null,
                repairAmount: this.formData.repairAmount,
                ...(params || {}),
            };
        },
        handleSubmit() {
            handleParameter({
                trackKey: 'equity_subsidy_repair_data_popup_dialog_operate',
                attr: {
                    button_type: 'confirm',
                },
            });
            this.$refs.formData.validate(async (valid) => {
                if (!valid) return;
                this.btnLoading = true;
                const { id } = this.dialogData.data;
                const requestParams = await this.constructRepairInfParams();
                await subsidyApplyApis.postRepairInfo(id, requestParams)
                    .then(() => {
                        this.$message({
                            type: 'success',
                            message: '提交成功',
                        });
                        this.dialogData.show = false;
                        this.$emit('refreshHandle');
                    })
                    .catch((err) => {
                        throw new Error(err);
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
            });
        },

        async handleStagingClick() {
            // 点击暂存
            const errs = [];
            Object.keys(this.formData).forEach((key) => {
                const value = this.formData[key];
                let rule = this.rules[key];
                if (key === 'repairCertificate' || key === 'worksTime') {
                    // 维修凭证跟进出厂时间是个数组，进行特殊判断
                    rule = value.length;
                }
                if (value && rule) {
                    this.$refs.formData.validateField(key, (errMessage) => {
                        if (errMessage) {
                            errs.push(rule);
                        }
                    });
                }
            });
            if (errs.length) return;
            this.stagingLoading = true;
            const { id } = this.dialogData.data;
            const requestParams = await this.constructRepairInfParams();
            Object.keys(requestParams).forEach((key) => { // 字段传null后端不校验
                if (!requestParams[key] && key !== 'waitDays') {
                    requestParams[key] = null;
                }
            });
            subsidyApplyApis.statingRepairInfo(id, requestParams)
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: '保存成功！',
                    });
                    this.dialogData.show = false;
                    this.$emit('refreshHandle');
                })
                .catch((err) => {
                    throw new Error(err);
                })
                .finally(() => {
                    this.stagingLoading = false;
                });
        },
        resetData() {
            this.$refs.formData.clearValidate();
            this.formData.repairAmount = '';
            this.formData.repairCertificate = [];
        },
        close() {
            handleParameter({
                trackKey: 'equity_subsidy_repair_data_popup_dialog_operate',
                attr: {
                    button_type: 'cancel',
                },
            });
            this.dialogData.show = false;
        },
        async calsSubsidyAmount() {
            if (!this.formData.subsidyDays || this.formData.subsidyDays < 1 || this.formData.subsidyDays > this.compareRepair || this.formData.subsidyDays > 999) {
                this.formData.subsidyAmount = 0;
                return;
            }
            if (!/^([1-9]\d{0,2})?$/.test(this.formData.subsidyDays)) return;
            await subsidyApplyApis.calsSubsidyAmount(this.dialogData.data.id, this.formData.subsidyDays)
                .then(({ data }) => {
                    this.formData.subsidyAmount = data;
                })
                .catch((err) => {
                    throw new Error(err);
                });
        },
    },
    filters: {
        photoTip,
        dateFormat,
    },
};
</script>
<style lang="scss" scoped>
    .submit-repair-info{
        .tips {
            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            line-height: 20px;
            margin: 5px 0 10px;
        }
        .footer {
            display: flex;
            justify-content: center;
            .el-button {
                width: 110px;
                padding: 8px 0 !important;
                margin: 0 32px 0 0;
                &:last-child {
                    margin: 0;
                }
            }
        }
    }
    .submit-repair-box {
        display: flex;
        .account-info {
            width: 280px;
            min-height: 350px;
            background: #F9F9F9;
            font-size: 14px;
            font-weight: 400;
            padding: 20px;
            .info-title {
                font-size: 14px;
                color: rgba(0,0,0,0.85);
                line-height: 20px;
                font-weight: bold;
                margin-bottom: 4px;
            }
            .info-tips {
                font-size: 12px;
                color: #999999;
                letter-spacing: 0;
                font-weight: 400;
                margin-bottom: 12px;
            }
            .info-item {
                display: flex;
                min-height: 20px;
                line-height: 20px;
                margin-bottom: 12px;
                .item-label {
                    color: #999999;
                    white-space: nowrap;
                }
                .item-value {
                    color: #333333;
                }
            }
        }
    }
</style>
<style lang="scss">
    .submit-repair-info{
        .el-dialog .el-dialog__body{
            padding: 0px;
        }
        .padding-left-10 {
            label.el-form-item__label {
                padding-left: 10px;
            }
        }
        .date {
            .el-input__prefix {
                display: none;
            }
        }
        .validate-base {
            position: absolute;
            padding-left: 16px;
            color: #F32E2E;
            font-size: 12px;
        }
        .validate-icon {
            content: "!";
            display: block;
            position: absolute;
            left: 0;
            top: 10px;
            width: 12px;
            height: 12px;
            line-height: 12px;
            border-radius: 50%;
            text-align: center;
            color: #fff;
            background-color: #F66C6C;
            font-size: 11px;
        }
        .validate-error-input {
            @extend .validate-base;
            top: 26px;
            .validate-error-tips {
                &::after {
                    @extend .validate-icon;
                }
            }
        }
        .validate-error {
            @extend .validate-base;
            top: 104px;
            .validate-error-tips {
                &::after {
                    @extend .validate-icon;
                }
            }
        }
        .upload {
            // height: 86px;
            overflow: hidden;
            .content-box {
                width: 100%;
                height: 100%;
            }
            .el-upload-list--picture-card .el-upload-list__item {
                width: 80px;
                height: 80px;
            }
            .el-upload--picture-card {
                width: 80px;
                height: 80px;
                line-height: 80px;
                @include font_color(color_base_gray6);
                @include bg_color(color_base_white);
            }
            // .el-icon-error {
            //     font-size: 20px;
            //     position: absolute;
            //     top: 5px;
            //     right: 5px;
            //     cursor: pointer;
            // }
            .delete-imgs {
                width: 20px;
                height: 20px;
                position: absolute;
                top: 4px;
                right: 4px;
                cursor: pointer;
                .delete-img{
                    font-size: 20px;
                }
            }
            .el-upload-list__item {
                transition-duration: .3s;
            }
        }
        .limit {
            .el-upload--picture-card {
                display: none;
            }
        }
        .el-upload-list--picture-card .el-upload-list__item-thumbnail {
            object-fit: cover;
        }
    }
</style>
